export default {
    excess: "Отговорност за излишък",
    security: "Гаранционна сума",
    fuel_policy: "Политика за гориво",
    like_for_like: "Като за като",
    full_to_full: "Пълно до пълно",
    mileage: "Пробег: {mileage} мили на прокат",
    unlimited_mileage: "Неограничен пробег",
    non_refundable: "Не се възстановява",
    free_cancellation_until: "Безплатно анулиране до {date}",
    cancellation_with_terms: "Анулиране {0} в съответствие с ",
    t_c_text: "Условията и правилата",
    two_free_extras: "Два безплатни допълнителни елемента при получаване",
    glass_tyres_covered: "Покритие на стъклата и гумите"
}